import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=06c660fc&scoped=true&"
import script from "./ImageCarousel.vue?vue&type=script&lang=ts&"
export * from "./ImageCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCarousel.vue?vue&type=style&index=0&id=06c660fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c660fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
